export default "__VITE_ASSET__c63321b8__"